<div #preventSwipe class="lyrics-tab lyrics-view">
  <section class="lyrics-section" *ngIf="activeTrack">
    <h3>{{activeTrack.name}}</h3>
    {{activeTrack.lyrics}}
  </section>
  <a class="lyrics-view-return" routerLink="/lyrics">Back</a>
</div>
